import {
  Cached,
  DarkMode,
  ExitToApp,
  MoreVert,
  Person,
} from "@mui/icons-material";
import { Box, Button, Divider, IconButton, Menu, Tooltip } from "@mui/material";
import { useAuth } from "react-oidc-context";

import useAlertStore from "@/store/use-alert-store";
import useAppStore from "@/store/use-app-store";
import { GetColorMode } from "contexts/ThemeContext";
import React, { useState } from "react";
import { SettingsExitButton } from "./ExitButton";
// import { useAuth } from "react-oidc-context";

export default function ProfileMenu(props) {
  const auth = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false); // const auth = useAuth();
  const { toggleColorMode } = GetColorMode();

  async function onCacheReset() {
    setAnchorEl(null);
    useAlertStore.persist.clearStorage();
    window.location.reload(false);
  }

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          padding: "12px",
        }}
      >
        <Button
          disableRipple
          onClick={() => {
            window.open(
              "https://login.5systems.ru/realms/5systems/account/#/",
              "_blank",
            );
          }}
          startIcon={<Person />}
          variant="contained"
        >
          Открыть профиль
        </Button>
        <Button
          disableRipple
          onClick={() => {
            toggleColorMode();
          }}
          startIcon={<DarkMode />}
          variant="contained"
        >
          Изменить тему
        </Button>
        {/* <PinField setAnchorEl={setAnchorEl} /> */}
        <Button
          disableRipple
          onClick={() => {
            onCacheReset();
          }}
          startIcon={<Cached />}
          variant="contained"
        >
          Очистить кэш
        </Button>
        <Divider sx={{ my: 0.5 }} />
        {/* <Button
          disableRipple
          onClick={() => {
            setOpen(true);
          }}
          startIcon={<Cached />}
          variant="contained"
        >
          Фоновые задания
        </Button> */}
        <Divider sx={{ my: 0.5 }} />

        <SettingsExitButton />
      </Box>
    </React.Fragment>
  );
}
